import { createContext } from 'react';

const initValue: any = [];
const Context = createContext(initValue);

export default Context;